<template>
<loader v-bind="{ loading }">
  <environment-not-setup v-if="!environment.attributes.length"/>
  <div v-else>
    <columns>
      <column>
        <columns>
          <column class="is-narrow is-flex align-center justify-center">
            <dropdown-wrapper
              position="left-start">
              <action-button class="is-rounded is-trigger" slot="trigger">
                <icon
                  class="cursor-pointer"
                  icon="ellipsis-v"
                />
              </action-button>

              <dropdown-item @click="downloadSnapshot">
                <icon class="mr" icon="download" />
                <span>Environment Snapshot</span>
              </dropdown-item>

              <dropdown-item @click="downloadOpenFindings">
                <icon class="mr" icon="download" />
                <span>Open Findings</span>
              </dropdown-item>
              
              <dropdown-item @click="downloadInstalledSoftware">
                <icon class="mr" icon="download" />
                <span>Software List</span>
              </dropdown-item>

              <dropdown-item @click="downloadRouteList">
                <icon class="mr" icon="download" />
                <span>Route List</span>
              </dropdown-item>

              <dropdown-item @click="downloadEventReport">
                <icon class="mr" icon="download" />
                <span>Event Report</span>
              </dropdown-item>
            </dropdown-wrapper>
          </column>
        </columns>

        <columns>
          <column>
            <dashboard :environment-id="$route.params.environment"/>
          </column>
        </columns>

      </column>

      <column class="is-3">
        <columns>
          <column class="has-text-right">
            <a v-if="environment.public_url" :href="'//' + environment.public_url" target="_blank" class="is-size-5">
              <span>{{ environment.public_url }}</span>
            </a>
            <p v-else>This environment is not publicly accessible</p>
          </column>
        </columns>
        <columns>
          <column>
            <flex class="justify-between">
              Laravel 
              <laravel-version class="has-text-weight-bold  has-text-secondary" :software="environment.software"/>
            </flex>
          </column>
          <column class="has-text-right">
            <flex class="justify-between">
              Git Branch
              <git-branch class="has-text-secondary" :attributes="environment.attributes"/>
            </flex>
          </column>
        </columns>
        <columns>
          <column>
            <flex class="justify-between">
              Routes
              <span class="has-text-weight-bold  has-text-secondary">{{ overview.total_route_count }}</span>
            </flex>            
          </column>
          <column>
            <flex class="justify-between">
              Attributes
              <span class="has-text-weight-bold  has-text-secondary">{{ overview.attribute_count }}</span>
            </flex>
          </column>
        </columns>
        <columns>
          <column>
            <flex class="justify-between">
              Middleware
              <span class="has-text-weight-bold  has-text-secondary">{{ overview.middleware_count }}</span>
            </flex>
          </column>
          <column>
            <flex class="justify-between">
              Models
              <span class="has-text-weight-bold  has-text-secondary">{{ overview.model_count }}</span>
            </flex>
          </column>
        </columns>
        <columns>
          <column>
            <flex class="justify-between">
              Security Events
              <span class="has-text-weight-bold has-text-secondary">{{ overview.event_count }}</span>
            </flex>
          </column>
          <column>
            <flex class="justify-between">
              Operations
              <span class="has-text-weight-bold  has-text-secondary">{{ overview.operation_count || 0 }}</span>
            </flex>
          </column>
        </columns>
      </column>
    </columns>

  </div>  
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'
import EnvironmentNotSetup from '@/views/apps/Environment/partials/NotSetup'
import TlsCertificate from '@/views/apps/Environment/partials/Tls'
import Software from '@/views/apps/Environment/partials/overview/Software'
import Dashboard from '@/views/apps/Environment/partials/overview/Dashboard'
import EnvironmentAttributes from '@/views/apps/Environment/partials/EnvironmentAttributes'
import LaravelVersion from '@/components/LaravelVersion.vue'
import GitBranch from '@/components/GitBranch.vue'
import download from 'downloadjs'
import { downloadFile } from '@/api/common'

export default {

  components: {
    Dashboard,
    EnvironmentNotSetup,
    Software,
    TlsCertificate,
    EnvironmentAttributes,
    LaravelVersion,
    GitBranch,
  },

  data: () => ({
    loading: false
  }),

  created() {
    this.$bus.$emit('set-title', `Environments`)
  },

  methods: {
    downloadSnapshot() {
      this.buildingToast()
      this.$toast.info('Building your report, please wait...')
      downloadFile(`/api/environment/${this.environment.id}/download-snapshot`, ({data}) => {
        download(data, `${this.environment.name}-snapshot.pdf`, 'application/pdf')
      })
    },

    downloadInstalledSoftware() {
      this.buildingToast()
      this.$toast.info('Building your report, please wait...')
      downloadFile(`/api/environment/${this.environment.id}/download-installed-software`, ({data}) => {
        download(data, `${this.environment.name}-installed-software.pdf`, 'application/pdf')
      }, error => {
        this.$toast.error('Whoops something went wrong')
      })
    },

    downloadRouteList() {
      this.buildingToast()
      this.$toast.info('Building your report, please wait...')
      downloadFile(`/api/environment/${this.environment.id}/download-route-list`, ({data}) => {
        download(data, `${this.environment.name}-routes.pdf`, 'application/pdf')
      }, error => {
        this.$toast.error('Whoops something went wrong')
      })
    },

    downloadOpenFindings() {
      this.buildingToast()
      this.$toast.info('Building your report, please wait...')
      downloadFile(`/api/environment/${this.environment.id}/download-open-findings`, ({data}) => {
        download(data, `${this.environment.name}-open-findings.pdf`, 'application/pdf')
      }, error => {
        this.$toast.error('Whoops something went wrong')
      })
    },

    downloadEventReport() {
      this.buildingToast()
      downloadFile(`/api/environment/${this.environment.id}/download-event-report`, ({data}) => {
        download(data, `${this.environment.name}-event-report.pdf`, 'application/pdf')
      }, error => {
        this.$toast.error('Whoops something went wrong')
      })
    },
    buildingToast() {
      this.$toast.info('Building your report, please wait...')
    }
  },

  computed: {
    ...mapGetters('environment', [
      'environment',
      'overview'
    ])
  }

}
</script>